import { Modal } from 'antd';
import { ProIconSvg } from '../../../icons/Pro.icon';
import { primaryColor, encountersToUnlock } from './config';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

const style = (
  /* eslint-disable-next-line react/no-unknown-property */
  <style jsx>{`
    .ripple-container {
      position: relative;
      display: inline-block;
    }
    .icon-container {
      position: relative;
      z-index: 2;
    }
    .ripple-container::before,
    .ripple-container::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      z-index: 1;
    }
    .ripple-container::before {
      width: calc(100% + 20px);
      height: calc(100% + 20px);
      background-color: rgba(0, 128, 0, 0.1);
    }
    .ripple-container::after {
      width: calc(100% + 40px);
      height: calc(100% + 40px);
      background-color: rgba(0, 128, 0, 0.05);
    }
  `}</style>
);

function FeatureOnboardingModal({ open, onCancel }) {
  const { user } = useAuth();

  const handleCancel = () => {
    analytics.track('Clicked Start My Journey To Pro In Unlock Modal', {
      email: user?.email,
    });
    onCancel?.();
  };

  return (
    <>
      {style}
      <Modal
        open={open}
        className="p-8"
        closable={false}
        footer={
          <div className="flex justify-center">
            <button className="ih-button-primary" onClick={handleCancel}>
              Start my journey to pro
            </button>
          </div>
        }
        centered
      >
        <div className="flex flex-col items-center text-center gap-4 mb-6">
          <div className="flex flex-col items-center p-6">
            <div className="ripple-container">
              <div
                className={`text-2xl font-semibold rounded-full bg-[${primaryColor}] p-4 icon-container`}
              >
                <ProIconSvg size={24} fill="white" />
              </div>
            </div>
          </div>
          <div className="text-2xl font-semibold">
            Unlock your pro plan trial!
          </div>
          <div className="text-sm text-gray-500">
            Great job getting started! Complete {encountersToUnlock} encounters
            to unlock a free 30-day Pro plan trial. Enhance your experience and
            discover powerful features!
          </div>
        </div>
      </Modal>
    </>
  );
}

export { FeatureOnboardingModal };
